import { useState } from "react";
import styles from "./ReportIssueModal.module.css";
import { toast } from 'react-toastify';

export default function ReportIssueModal({ show, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    type: "",
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/report-issue`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("Enquiry submitted successfully!");

        setFormData({ type: "", name: "", mobile: "", email: "", message: "" });
        onClose?.();
      } else {
        toast.error(data.message || "Failed to submit enquiry. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };


  if (!show) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Report an Issue</h2>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label>Report Type</label>
            <select name="type" value={formData.type} onChange={handleChange} required>
              <option value="">Select a type</option>
              <option value="bug">A Bug</option>
              <option value="issue">An Issue</option>
              <option value="feedback">Feedback / Suggestion</option>
            </select>
          </div>

          <div className={styles.field}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Your full name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.fieldRow}>
            <div className={styles.field}>
              <label>Mobile</label>
              <input
                type="tel"
                name="mobile"
                placeholder="+91 9876543210"
                value={formData.mobile}
                onChange={handleChange}
              />
            </div>

            <div className={styles.field}>
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="you@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className={styles.field}>
            <label>Message</label>
            <textarea
              name="message"
              placeholder="Describe the issue briefly..."
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles.submitBtn}>
              Submit Report
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
